export default __webpack_public_path__ + "static/media/icon-search-dark.6dd1e613.svg";